function updateSelectedWobs (canvas, update) {
	canvas.selection.wobs
		.filter(w => !w.get('locked'))
		.forEach(update)
}

export default updateSelectedWobs

updateSelectedWobs.__filename__ = 'dashboards/widgets/update-selected-wobs.js'
